import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../../../apiLayer/queryKeys'
import { processHandlers } from '../../../../apiLayer/processHandlers'

/**
 * Imperatively prefetches sprint wizard config data into the React Query cache.
 * Call this in any facilitator page that leads to the sprint creation wizard so
 * the data is already cached by the time Step 1 renders.
 *
 * staleTime matches the useSprintPurposeConfigs / useSprintActivityTypeConfigs hooks (5 min).
 * If data is already fresh in cache, prefetchQuery is a no-op.
 */
export function usePrefetchSprintWizardConfig() {
  const queryClient = useQueryClient()

  useEffect(() => {
    const STALE_TIME = 5 * 60 * 1000

    queryClient.prefetchQuery({
      queryKey: [QUERY_KEYS.SPRINT_PURPOSE_CONFIGS],
      queryFn: () => processHandlers.getSprintPurposeConfigs(),
      staleTime: STALE_TIME
    })

    queryClient.prefetchQuery({
      queryKey: [QUERY_KEYS.SPRINT_ACTIVITY_TYPE_CONFIGS],
      queryFn: () => processHandlers.getSprintActivityTypeConfigs(),
      staleTime: STALE_TIME
    })
  }, [queryClient])
}
